import React from 'react';
import { Box, List, ListItem, ListItemButton, Typography } from '@mui/material';
import { useKBTheme } from '../hooks/useKBTheme';
import { useNavigate, useLocation } from 'react-router-dom';

interface SidebarItem {
  id: string;
  title: string;
  path: string;
  children?: SidebarItem[];
}

const sidebarItems: SidebarItem[] = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    path: '/knowledge-base/category/getting-started',
  },
  {
    id: 'admin',
    title: 'Admin Console',
    path: '/knowledge-base/category/admin',
  },
  {
    id: 'smart-policies',
    title: 'Smart Policies',
    path: '/knowledge-base/category/smart-policies',
  },
  {
    id: 'chat',
    title: 'Chat Interface',
    path: '/knowledge-base/category/chat',
  },
  {
    id: 'tickets',
    title: 'Tickets App',
    path: '/knowledge-base/category/tickets',
  },
  {
    id: 'teams-roles',
    title: 'Teams & Roles',
    path: '/knowledge-base/category/teams-roles',
  },
  {
    id: 'best-practices',
    title: 'Best Practices',
    path: '/knowledge-base/category/best-practices',
  },
];

export const KBSidebar: React.FC = () => {
  const { mode } = useKBTheme();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box
      sx={{
        width: 280,
        height: 'calc(100vh - 80px)',
        position: 'sticky',
        top: 80,
        overflowY: 'auto',
        borderRight: mode === 'dark'
          ? '1px solid rgba(71, 85, 105, 0.4)'
          : '1px solid rgba(226, 232, 240, 0.8)',
        background: mode === 'dark'
          ? 'rgba(15, 23, 42, 0.5)'
          : 'rgba(255, 255, 255, 0.5)',
        px: 2,
        py: 3,
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: mode === 'dark' ? 'rgba(71, 85, 105, 0.6)' : 'rgba(226, 232, 240, 0.8)',
          borderRadius: '4px',
        },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          mb: 2,
          color: mode === 'dark' ? '#fff' : '#0f172a',
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
        }}
      >
        Categories
      </Typography>
      <List sx={{ p: 0 }}>
        {sidebarItems.map((item, index) => {
          const isActive = location.pathname.includes(item.path);
          return (
            <React.Fragment key={item.id}>
              <ListItem disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                  onClick={() => navigate(item.path)}
                  sx={{
                    borderRadius: 2,
                    py: 1.5,
                    px: 2,
                    background: isActive
                      ? mode === 'dark'
                        ? 'rgba(99, 102, 241, 0.2)'
                        : 'rgba(99, 102, 241, 0.1)'
                      : 'transparent',
                    color: isActive
                      ? '#6366f1'
                      : mode === 'dark'
                      ? 'rgba(255, 255, 255, 0.8)'
                      : '#475569',
                    fontWeight: isActive ? 600 : 500,
                    '&:hover': {
                      background: mode === 'dark'
                        ? 'rgba(99, 102, 241, 0.15)'
                        : 'rgba(99, 102, 241, 0.08)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  {item.title}
                </ListItemButton>
              </ListItem>
            </React.Fragment>
          );
        })}
      </List>
    </Box>
  );
};

